<template>
  <div class="content">
    <ToolTitle :title="form.name" :menu="true" :menuby="'company'" />
    <ToolLoading v-if="!isloaded" />
    <div v-if="isloaded" class="content__form">
      <FormInput :placeholder="'Marka adı:'" :required="true" v-model.trim="form.name" />
      <TypeImage v-if="form.image" v-model="form.image" />
      <FormUpload
        v-else
        :title="'Marka Logosu'"
        :fileType="'image/*'"
        :labelFor="'logo'"
        v-model="form.image"
      />
      <TypePdf v-if="form.pdf" v-model="form.pdf" />
      <FormUpload
        v-else
        :title="'Marka KVKK Pdf'"
        :fileType="'application/pdf'"
        :labelFor="'kvkk'"
        v-model="form.pdf"
      />
      <FormInfo :title="'Oluşturan:'" :text="`${form.created.by} - ${form.created.date}`" />
      <FormInfo
        v-if="form.updated.date"
        :title="'Son düzenleyen:'"
        :text="`${form.updated.by} - ${form.updated.date}`"
      />
      <FormButton @action="update()" :text="'Kaydet'" :status="status" />
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import * as Helpers from "@/helpers/";

export default {
  data() {
    return {
      company: this.$store.getters.getActiveCompany,
      form: {},
      isloaded: false,
      status: {
        loading: false,
        message: "",
        type: "",
      },
    };
  },
  computed: {
    tabs() {
      let _tabs = this.$router.options.routes.filter(
        (item) => item.name == "company"
      )[0].children;

      return _tabs;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init: async function () {
      let vm = this;

      let _company = vm.$store.getters.getActiveCompany;

      await API.getCompany(_company.path).then((response) => {
        vm.form = response.result;
      });

      setTimeout(() => {
        vm.isloaded = true;
      }, 300);
    },
    update: async function () {
      let vm = this;

      vm.status.loading = true;
      vm.status.type = "";
      vm.status.message = "Form düzenleniyor...";

      vm.form.updated = {
        by: vm.$store.getters.getUser,
        date: await Helpers.currentDateTime(),
      };

      await API.updateCompany(vm.form)
        .then(async (response) => {
          vm.status.type = "Success";
          if (response.status.code != 200) vm.status.type = "Error";
          vm.status.message = response.status.message;

          await this.$store.dispatch(
            "setActiveCompany",
            response.result.company
          );
        })
        .catch((error) => {
          vm.status.type = "Error";
          vm.status.message = error;
        });

      vm.status.loading = false;
      vm.init();
    },
  },
};
</script>